import { type ExamineeCountryCode, RegistrationDocType } from '@exam-center/graphql';
import {
  EXAMINEE_ENGLISH_TITLE_OPTIONS,
  isExamineeEnglishTitle,
  type ExamineeEnglishTitle,
} from '@shared/utils';

import {
  type CountryCode,
  type DocumentType,
  CountryCodeLabelMap,
  CountryCodeList,
} from '../../constants';

export function getCountryCodeOptions() {
  return CountryCodeList.map((code: CountryCode) => ({
    label: code.label,
    value: code.key,
  }));
}

export function getEnglishNameTitleOptions() {
  return EXAMINEE_ENGLISH_TITLE_OPTIONS;
}

export function convertStringToNameTitle(nameTitle: string): ExamineeEnglishTitle | null {
  return isExamineeEnglishTitle(nameTitle) ? nameTitle : null;
}

export function getStringCountryCode(countryCode: ExamineeCountryCode | null | undefined) {
  return countryCode ? (CountryCodeLabelMap.get(countryCode) ?? '') : '';
}

export function convertToRegistrationType(documentType: DocumentType) {
  switch (documentType) {
    case 'CITIZEN_CARD':
      return RegistrationDocType.CitizenCard;
    case 'DRIVER_LICENSE':
      return RegistrationDocType.DriverLicense;
    case 'PASSPORT':
      return RegistrationDocType.Passport;
    case 'DIGITAL_DOCUMENT':
      return RegistrationDocType.DigitalDocument;
  }
}
